import { useCallback, useEffect, useState } from 'react';
import { statsAPI } from '../services/api';

/** Tenant-wide (entire system) record count for a module */
export function useSystemTotal(moduleKey: string, fallback = 0) {
  const [total, setTotal] = useState<number | null>(null);

  const refresh = useCallback(async () => {
    if (!moduleKey) {
      setTotal(fallback);
      return;
    }
    try {
      const res = await statsAPI.systemTotal(moduleKey);
      setTotal(Number(res.data?.total) || 0);
    } catch {
      setTotal(fallback);
    }
  }, [moduleKey, fallback]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { total: total != null ? total : fallback, refresh, setFallback: setTotal };
}
